module.exports = __webpack_public_path__ + "static/policy_book1_4@2x-590b0e0503dd75a4c24bbfc527d2965a.png";